// extracted by mini-css-extract-plugin
export default {"item":"brand_notifications_form__item--GXos","label":"brand_notifications_form__label--m8jE"};